import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/promoCodes'

class PromoCodeDataService extends RestApiDataService {
  getNegativeItems () {
    return this.getCustomItems('negative')
  }

  getReadyForUseItems ({ basketId }) {
    return this.getCustomItems('ready-for-use', { basketId })
  }
}

export default new PromoCodeDataService(BASE_ENTITY_URL)
